/* Health Capsules — global JS */
document.addEventListener('DOMContentLoaded', () => {
  // Product gallery thumbs
  document.querySelectorAll('.product-gallery').forEach(g => {
    const main = g.querySelector('.main-img img');
    g.querySelectorAll('.thumbs button').forEach(b => {
      b.addEventListener('click', () => {
        g.querySelectorAll('.thumbs button').forEach(x => x.classList.remove('active'));
        b.classList.add('active');
        if (main) main.src = b.dataset.src;
      });
    });
  });

  // Tabs
  document.querySelectorAll('.tabs').forEach(t => {
    const btns = t.querySelectorAll('.tab-btns button');
    const panels = t.querySelectorAll('.tab-panel');
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.classList.remove('active'));
      panels.forEach(p => p.classList.remove('active'));
      b.classList.add('active');
      const id = b.dataset.tab;
      const target = t.querySelector(`.tab-panel[data-tab="${id}"]`);
      if (target) target.classList.add('active');
    }));
  });

  // Quantity steppers
  document.querySelectorAll('.qty').forEach(q => {
    const input = q.querySelector('input');
    q.querySelector('.minus')?.addEventListener('click', () => {
      input.value = Math.max(1, (parseInt(input.value) || 1) - 1);
    });
    q.querySelector('.plus')?.addEventListener('click', () => {
      input.value = (parseInt(input.value) || 1) + 1;
    });
  });
});
